import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import AppBody from "./appBody";
import "./stylesheets/index.scss";
import AppWrappers from "./appWrappers";
import { Toaster } from "sonner";
import { HeroUIProvider } from "@heroui/react";
import { useHref, useNavigate } from "react-router-dom";

/**
 * RouterProvider is a functional component that provides navigation and link handling for the application.
 *
 * @returns {JSX.Element} The React element containing the HeroUIProvider with navigational properties.
 */
function RouterProvider() {
  const navigate = useNavigate();
  const href = useHref;

  return (
    <HeroUIProvider navigate={navigate} useHref={href}>
      <AppBody />
    </HeroUIProvider>
  );
}

/**
 * The main application component
 */
export default function App() {
  return (
    <AppWrappers>
      <Toaster
        position="top-center"
        richColors
        className="flex justify-center"
        toastOptions={{
          className:
            "flex items-center justify-center w-auto whitespace-nowrap ",
        }}
      />
      <RouterProvider />
      <ReactQueryDevtools initialIsOpen={false} />
    </AppWrappers>
  );
}
